// cpcCharset.ts
//

/* eslint-disable array-element-newline */

export const cpcCharset = [ // eslint-disable-line no-unused-vars
	[0xff, 0xc3, 0xc3, 0xc3, 0xc3, 0xc3, 0xc3, 0xff], // 0x00
	[0xff, 0xc0, 0xc0, 0xc0, 0xc0, 0xc0, 0xc0, 0xc0], // 0x01
	[0x18, 0x18, 0x18, 0x18, 0x18, 0x18, 0x18, 0xff], // 0x02
	[0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0xff], // 0x03
	[0x0c, 0x18, 0x30, 0x7e, 0x0c, 0x18, 0x30, 0x00], // 0x04
	[0xff, 0xc3, 0xe7, 0xdb, 0xdb, 0xe7, 0xc3, 0xff], // 0x05
	[0x00, 0x01, 0x03, 0x06, 0xcc, 0x78, 0x30, 0x00], // 0x06
	[0x3c, 0x66, 0xc3, 0xc3, 0xff, 0x24, 0xe7, 0x00], // 0x07
	[0x00, 0x00, 0x30, 0x60, 0xff, 0x60, 0x30, 0x00], // 0x08
	[0x00, 0x00, 0x0c, 0x06, 0xff, 0x06, 0x0c, 0x00], // 0x09
	[0x18, 0x18, 0x18, 0x18, 0xdb, 0x7e, 0x3c, 0x18], // 0x0a
	[0x18, 0x3c, 0x7e, 0xdb, 0x18, 0x18, 0x18, 0x18], // 0x0b
	[0x18, 0x5a, 0x3c, 0x99, 0xdb, 0x7e, 0x3c, 0x18], // 0x0c
	[0x00, 0x03, 0x33, 0x63, 0xfe, 0x60, 0x30, 0x00], // 0x0d
	[0x3c, 0x66, 0xff, 0xdb, 0xdb, 0xff, 0x66, 0x3c], // 0x0e
	[0x3c, 0x66, 0xc3, 0xdb, 0xdb, 0xc3, 0x66, 0x3c], // 0x0f
	[0xff, 0xc3, 0xc3, 0xff, 0xc3, 0xc3, 0xc3, 0xff], // 0x10
	[0x3c, 0x7e, 0xdb, 0xdb, 0xdf, 0xc3, 0x66, 0x3c], // 0x11
	[0x3c, 0x66, 0xc3, 0xdf, 0xdb, 0xdb, 0x7e, 0x3c], // 0x12
	[0x3c, 0x66, 0xc3, 0xfb, 0xdb, 0xdb, 0x7e, 0x3c], // 0x13
	[0x3c, 0x7e, 0xdb, 0xdb, 0xfb, 0xc3, 0x66, 0x3c], // 0x14
	[0x00, 0x01, 0x33, 0x1e, 0xce, 0x7b, 0x31, 0x00], // 0x15
	[0x7e, 0x66, 0x66, 0x66, 0x66, 0x66, 0x66, 0xe7], // 0x16
	[0x03, 0x03, 0x03, 0xff, 0x03, 0x03, 0x03, 0x00], // 0x17
	[0xff, 0x66, 0x3c, 0x18, 0x18, 0x3c, 0x66, 0xff], // 0x18
	[0x18, 0x18, 0x3c, 0x3c, 0x3c, 0x3c, 0x18, 0x18], // 0x19
	[0x3c, 0x66, 0x66, 0x30, 0x18, 0x00, 0x18, 0x00], // 0x1a
	[0x3c, 0x66, 0xc3, 0xff, 0xc3, 0xc3, 0x66, 0x3c], // 0x1b
	[0xff, 0xdb, 0xdb, 0xdb, 0xfb, 0xc3, 0xc3, 0xff], // 0x1c
	[0xff, 0xc3, 0xc3, 0xfb, 0xdb, 0xdb, 0xdb, 0xff], // 0x1d
	[0xff, 0xc3, 0xc3, 0xdf, 0xdb, 0xdb, 0xdb, 0xff], // 0x1e
	[0xff, 0xdb, 0xdb, 0xdb, 0xdf, 0xc3, 0xc3, 0xff], // 0x1f
	[0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], // 0x20
	[0x18, 0x18, 0x18, 0x18, 0x18, 0x00, 0x18, 0x00], // 0x21
	[0x6c, 0x6c, 0x6c, 0x00, 0x00, 0x00, 0x00, 0x00], // 0x22
	[0x6c, 0x6c, 0xfe, 0x6c, 0xfe, 0x6c, 0x6c, 0x00], // 0x23
	[0x18, 0x3e, 0x58, 0x3c, 0x1a, 0x7c, 0x18, 0x00], // 0x24
	[0x00, 0xc6, 0xcc, 0x18, 0x30, 0x66, 0xc6, 0x00], // 0x25
	[0x38, 0x6c, 0x38, 0x76, 0xdc, 0xcc, 0x76, 0x00], // 0x26
	[0x18, 0x18, 0x30, 0x00, 0x00, 0x00, 0x00, 0x00], // 0x27
	[0x0c, 0x18, 0x30, 0x30, 0x30, 0x18, 0x0c, 0x00], // 0x28
	[0x30, 0x18, 0x0c, 0x0c, 0x0c, 0x18, 0x30, 0x00], // 0x29
	[0x00, 0x66, 0x3c, 0xff, 0x3c, 0x66, 0x00, 0x00], // 0x2a
	[0x00, 0x18, 0x18, 0x7e, 0x18, 0x18, 0x00, 0x00], // 0x2b
	[0x00, 0x00, 0x00, 0x00, 0x00, 0x18, 0x18, 0x30], // 0x2c
	[0x00, 0x00, 0x00, 0x7e, 0x00, 0x00, 0x00, 0x00], // 0x2d
	[0x00, 0x00, 0x00, 0x00, 0x00, 0x18, 0x18, 0x00], // 0x2e
	[0x06, 0x0c, 0x18, 0x30, 0x60, 0xc0, 0x80, 0x00], // 0x2f
	[0x7c, 0xc6, 0xce, 0xd6, 0xe6, 0xc6, 0x7c, 0x00], // 0x30
	[0x18, 0x38, 0x18, 0x18, 0x18, 0x18, 0x7e, 0x00], // 0x31
	[0x3c, 0x66, 0x06, 0x3c, 0x60, 0x66, 0x7e, 0x00], // 0x32
	[0x3c, 0x66, 0x06, 0x1c, 0x06, 0x66, 0x3c, 0x00], // 0x33
	[0x1c, 0x3c, 0x6c, 0xcc, 0xfe, 0x0c, 0x1e, 0x00], // 0x34
	[0x7e, 0x62, 0x60, 0x7c, 0x06, 0x66, 0x3c, 0x00], // 0x35
	[0x3c, 0x66, 0x60, 0x7c, 0x66, 0x66, 0x3c, 0x00], // 0x36
	[0x7e, 0x66, 0x06, 0x0c, 0x18, 0x18, 0x18, 0x00], // 0x37
	[0x3c, 0x66, 0x66, 0x3c, 0x66, 0x66, 0x3c, 0x00], // 0x38
	[0x3c, 0x66, 0x66, 0x3e, 0x06, 0x66, 0x3c, 0x00], // 0x39
	[0x00, 0x00, 0x18, 0x18, 0x00, 0x18, 0x18, 0x00], // 0x3a
	[0x00, 0x00, 0x18, 0x18, 0x00, 0x18, 0x18, 0x30], // 0x3b
	[0x0c, 0x18, 0x30, 0x60, 0x30, 0x18, 0x0c, 0x00], // 0x3c
	[0x00, 0x00, 0x7e, 0x00, 0x00, 0x7e, 0x00, 0x00], // 0x3d
	[0x60, 0x30, 0x18, 0x0c, 0x18, 0x30, 0x60, 0x00], // 0x3e
	[0x3c, 0x66, 0x66, 0x0c, 0x18, 0x00, 0x18, 0x00], // 0x3f
	[0x7c, 0xc6, 0xde, 0xde, 0xde, 0xc0, 0x7c, 0x00], // 0x40
	[0x18, 0x3c, 0x66, 0x66, 0x7e, 0x66, 0x66, 0x00], // 0x41
	[0xfc, 0x66, 0x66, 0x7c, 0x66, 0x66, 0xfc, 0x00], // 0x42
	[0x3c, 0x66, 0xc0, 0xc0, 0xc0, 0x66, 0x3c, 0x00], // 0x43
	[0xf8, 0x6c, 0x66, 0x66, 0x66, 0x6c, 0xf8, 0x00], // 0x44
	[0xfe, 0x62, 0x68, 0x78, 0x68, 0x62, 0xfe, 0x00], // 0x45
	[0xfe, 0x62, 0x68, 0x78, 0x68, 0x60, 0xf0, 0x00], // 0x46
	[0x3c, 0x66, 0xc0, 0xc0, 0xce, 0x66, 0x3e, 0x00], // 0x47
	[0x66, 0x66, 0x66, 0x7e, 0x66, 0x66, 0x66, 0x00], // 0x48
	[0x7e, 0x18, 0x18, 0x18, 0x18, 0x18, 0x7e, 0x00], // 0x49
	[0x1e, 0x0c, 0x0c, 0x0c, 0xcc, 0xcc, 0x78, 0x00], // 0x4a
	[0xe6, 0x66, 0x6c, 0x78, 0x6c, 0x66, 0xe6, 0x00], // 0x4b
	[0xf0, 0x60, 0x60, 0x60, 0x62, 0x66, 0xfe, 0x00], // 0x4c
	[0xc6, 0xee, 0xfe, 0xfe, 0xd6, 0xc6, 0xc6, 0x00], // 0x4d
	[0xc6, 0xe6, 0xf6, 0xde, 0xce, 0xc6, 0xc6, 0x00], // 0x4e
	[0x38, 0x6c, 0xc6, 0xc6, 0xc6, 0x6c, 0x38, 0x00], // 0x4f
	[0xfc, 0x66, 0x66, 0x7c, 0x60, 0x60, 0xf0, 0x00], // 0x50
	[0x38, 0x6c, 0xc6, 0xc6, 0xda, 0xcc, 0x76, 0x00], // 0x51
	[0xfc, 0x66, 0x66, 0x7c, 0x6c, 0x66, 0xe6, 0x00], // 0x52
	[0x3c, 0x66, 0x60, 0x3c, 0x06, 0x66, 0x3c, 0x00], // 0x53
	[0x7e, 0x5a, 0x18, 0x18, 0x18, 0x18, 0x3c, 0x00], // 0x54
	[0x66, 0x66, 0x66, 0x66, 0x66, 0x66, 0x3c, 0x00], // 0x55
	[0x66, 0x66, 0x66, 0x66, 0x66, 0x3c, 0x18, 0x00], // 0x56
	[0xc6, 0xc6, 0xc6, 0xd6, 0xfe, 0xee, 0xc6, 0x00], // 0x57
	[0xc6, 0x6c, 0x38, 0x38, 0x6c, 0xc6, 0xc6, 0x00], // 0x58
	[0x66, 0x66, 0x66, 0x3c, 0x18, 0x18, 0x3c, 0x00], // 0x59
	[0xfe, 0xc6, 0x8c, 0x18, 0x32, 0x66, 0xfe, 0x00], // 0x5a
	[0x3c, 0x30, 0x30, 0x30, 0x30, 0x30, 0x3c, 0x00], // 0x5b
	[0xc0, 0x60, 0x30, 0x18, 0x0c, 0x06, 0x02, 0x00], // 0x5c
	[0x3c, 0x0c, 0x0c, 0x0c, 0x0c, 0x0c, 0x3c, 0x00], // 0x5d
	[0x18, 0x3c, 0x7e, 0x18, 0x18, 0x18, 0x18, 0x00], // 0x5e
	[0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xff], // 0x5f
	[0x30, 0x18, 0x0c, 0x00, 0x00, 0x00, 0x00, 0x00], // 0x60
	[0x00, 0x00, 0x78, 0x0c, 0x7c, 0xcc, 0x76, 0x00], // 0x61
	[0xe0, 0x60, 0x7c, 0x66, 0x66, 0x66, 0xdc, 0x00], // 0x62
	[0x00, 0x00, 0x3c, 0x66, 0x60, 0x66, 0x3c, 0x00], // 0x63
	[0x1c, 0x0c, 0x7c, 0xcc, 0xcc, 0xcc, 0x76, 0x00], // 0x64
	[0x00, 0x00, 0x3c, 0x66, 0x7e, 0x60, 0x3c, 0x00], // 0x65
	[0x1c, 0x36, 0x30, 0x78, 0x30, 0x30, 0x78, 0x00], // 0x66
	[0x00, 0x00, 0x3e, 0x66, 0x66, 0x3e, 0x06, 0x7c], // 0x67
	[0xe0, 0x60, 0x6c, 0x76, 0x66, 0x66, 0xe6, 0x00], // 0x68
	[0x18, 0x00, 0x38, 0x18, 0x18, 0x18, 0x3c, 0x00], // 0x69
	[0x06, 0x00, 0x0e, 0x06, 0x06, 0x66, 0x66, 0x3c], // 0x6a
	[0xe0, 0x60, 0x66, 0x6c, 0x78, 0x6c, 0xe6, 0x00], // 0x6b
	[0x38, 0x18, 0x18, 0x18, 0x18, 0x18, 0x3c, 0x00], // 0x6c
	[0x00, 0x00, 0x6c, 0xfe, 0xd6, 0xd6, 0xc6, 0x00], // 0x6d
	[0x00, 0x00, 0xdc, 0x66, 0x66, 0x66, 0x66, 0x00], // 0x6e
	[0x00, 0x00, 0x3c, 0x66, 0x66, 0x66, 0x3c, 0x00], // 0x6f
	[0x00, 0x00, 0xdc, 0x66, 0x66, 0x7c, 0x60, 0xf0], // 0x70
	[0x00, 0x00, 0x76, 0xcc, 0xcc, 0x7c, 0x0c, 0x1e], // 0x71
	[0x00, 0x00, 0xdc, 0x76, 0x60, 0x60, 0xf0, 0x00], // 0x72
	[0x00, 0x00, 0x3c, 0x60, 0x3c, 0x06, 0x7c, 0x00], // 0x73
	[0x30, 0x30, 0x7c, 0x30, 0x30, 0x36, 0x1c, 0x00], // 0x74
	[0x00, 0x00, 0x66, 0x66, 0x66, 0x66, 0x3e, 0x00], // 0x75
	[0x00, 0x00, 0x66, 0x66, 0x66, 0x3c, 0x18, 0x00], // 0x76
	[0x00, 0x00, 0xc6, 0xd6, 0xd6, 0xfe, 0x6c, 0x00], // 0x77
	[0x00, 0x00, 0xc6, 0x6c, 0x38, 0x6c, 0xc6, 0x00], // 0x78
	[0x00, 0x00, 0x66, 0x66, 0x66, 0x3e, 0x06, 0x7c], // 0x79
	[0x00, 0x00, 0x7e, 0x4c, 0x18, 0x32, 0x7e, 0x00], // 0x7a
	[0x0e, 0x18, 0x18, 0x70, 0x18, 0x18, 0x0e, 0x00], // 0x7b
	[0x18, 0x18, 0x18, 0x18, 0x18, 0x18, 0x18, 0x00], // 0x7c
	[0x70, 0x18, 0x18, 0x0e, 0x18, 0x18, 0x70, 0x00], // 0x7d
	[0x76, 0xdc, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], // 0x7e
	[0xcc, 0x33, 0xcc, 0x33, 0xcc, 0x33, 0xcc, 0x33], // 0x7f
	[0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], // 0x80
	[0xf0, 0xf0, 0xf0, 0xf0, 0x00, 0x00, 0x00, 0x00], // 0x81
	[0x0f, 0x0f, 0x0f, 0x0f, 0x00, 0x00, 0x00, 0x00], // 0x82
	[0xff, 0xff, 0xff, 0xff, 0x00, 0x00, 0x00, 0x00], // 0x83
	[0x00, 0x00, 0x00, 0x00, 0xf0, 0xf0, 0xf0, 0xf0], // 0x84
	[0xf0, 0xf0, 0xf0, 0xf0, 0xf0, 0xf0, 0xf0, 0xf0], // 0x85
	[0x0f, 0x0f, 0x0f, 0x0f, 0xf0, 0xf0, 0xf0, 0xf0], // 0x86
	[0xff, 0xff, 0xff, 0xff, 0xf0, 0xf0, 0xf0, 0xf0], // 0x87
	[0x00, 0x00, 0x00, 0x00, 0x0f, 0x0f, 0x0f, 0x0f], // 0x88
	[0xf0, 0xf0, 0xf0, 0xf0, 0x0f, 0x0f, 0x0f, 0x0f], // 0x89
	[0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f], // 0x8a
	[0xff, 0xff, 0xff, 0xff, 0x0f, 0x0f, 0x0f, 0x0f], // 0x8b
	[0x00, 0x00, 0x00, 0x00, 0xff, 0xff, 0xff, 0xff], // 0x8c
	[0xf0, 0xf0, 0xf0, 0xf0, 0xff, 0xff, 0xff, 0xff], // 0x8d
	[0x0f, 0x0f, 0x0f, 0x0f, 0xff, 0xff, 0xff, 0xff], // 0x8e
	[0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff], // 0x8f
	[0x00, 0x00, 0x00, 0x18, 0x18, 0x00, 0x00, 0x00], // 0x90
	[0x18, 0x18, 0x18, 0x18, 0x18, 0x00, 0x00, 0x00], // 0x91
	[0x00, 0x00, 0x00, 0x1f, 0x1f, 0x00, 0x00, 0x00], // 0x92
	[0x18, 0x18, 0x18, 0x1f, 0x0f, 0x00, 0x00, 0x00], // 0x93
	[0x00, 0x00, 0x00, 0x18, 0x18, 0x18, 0x18, 0x18], // 0x94
	[0x18, 0x18, 0x18, 0x18, 0x18, 0x18, 0x18, 0x18], // 0x95
	[0x00, 0x00, 0x00, 0x0f, 0x1f, 0x18, 0x18, 0x18], // 0x96
	[0x18, 0x18, 0x18, 0x1f, 0x1f, 0x18, 0x18, 0x18], // 0x97
	[0x00, 0x00, 0x00, 0xf8, 0xf8, 0x00, 0x00, 0x00], // 0x98
	[0x18, 0x18, 0x18, 0xf8, 0xf0, 0x00, 0x00, 0x00], // 0x99
	[0x00, 0x00, 0x00, 0xff, 0xff, 0x00, 0x00, 0x00], // 0x9a
	[0x18, 0x18, 0x18, 0xff, 0xff, 0x00, 0x00, 0x00], // 0x9b
	[0x00, 0x00, 0x00, 0xf0, 0xf8, 0x18, 0x18, 0x18], // 0x9c
	[0x18, 0x18, 0x18, 0xf8, 0xf8, 0x18, 0x18, 0x18], // 0x9d
	[0x00, 0x00, 0x00, 0xff, 0xff, 0x18, 0x18, 0x18], // 0x9e
	[0x18, 0x18, 0x18, 0xff, 0xff, 0x18, 0x18, 0x18], // 0x9f
	[0x10, 0x38, 0x6c, 0xc6, 0x00, 0x00, 0x00, 0x00], // 0xa0
	[0x0c, 0x18, 0x30, 0x00, 0x00, 0x00, 0x00, 0x00], // 0xa1
	[0x66, 0x66, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], // 0xa2
	[0x3c, 0x66, 0x60, 0xf8, 0x60, 0x66, 0xfe, 0x00], // 0xa3
	[0x38, 0x44, 0xba, 0xa2, 0xba, 0x44, 0x38, 0x00], // 0xa4
	[0x7e, 0xf4, 0xf4, 0x74, 0x34, 0x34, 0x34, 0x00], // 0xa5
	[0x1e, 0x30, 0x38, 0x6c, 0x38, 0x18, 0xf0, 0x00], // 0xa6
	[0x18, 0x18, 0x0c, 0x00, 0x00, 0x00, 0x00, 0x00], // 0xa7
	[0x40, 0xc0, 0x44, 0x4c, 0x54, 0x1e, 0x04, 0x00], // 0xa8
	[0x40, 0xc0, 0x4c, 0x52, 0x44, 0x08, 0x1e, 0x00], // 0xa9
	[0xe0, 0x10, 0x62, 0x16, 0xea, 0x0f, 0x02, 0x00], // 0xaa
	[0x00, 0x18, 0x18, 0x7e, 0x18, 0x18, 0x7e, 0x00], // 0xab
	[0x18, 0x18, 0x00, 0x7e, 0x00, 0x18, 0x18, 0x00], // 0xac
	[0x00, 0x00, 0x00, 0x7e, 0x06, 0x06, 0x00, 0x00], // 0xad
	[0x18, 0x00, 0x18, 0x30, 0x66, 0x66, 0x3c, 0x00], // 0xae
	[0x18, 0x00, 0x18, 0x18, 0x18, 0x18, 0x18, 0x00], // 0xaf
	[0x00, 0x00, 0x73, 0xde, 0xcc, 0xde, 0x73, 0x00], // 0xb0
	[0x7c, 0xc6, 0xc6, 0xfc, 0xc6, 0xc6, 0xf8, 0xc0], // 0xb1
	[0x00, 0x66, 0x66, 0x3c, 0x66, 0x66, 0x3c, 0x00], // 0xb2
	[0x3c, 0x60, 0x60, 0x3c, 0x66, 0x66, 0x3c, 0x00], // 0xb3
	[0x00, 0x00, 0x1e, 0x30, 0x7c, 0x30, 0x1e, 0x00], // 0xb4
	[0x38, 0x6c, 0xc6, 0xfe, 0xc6, 0x6c, 0x38, 0x00], // 0xb5
	[0x00, 0xc0, 0x60, 0x30, 0x38, 0x6c, 0xc6, 0x00], // 0xb6
	[0x00, 0x00, 0x66, 0x66, 0x66, 0x7c, 0x60, 0x60], // 0xb7
	[0x00, 0x00, 0x00, 0xfe, 0x6c, 0x6c, 0x6c, 0x00], // 0xb8
	[0x00, 0x00, 0x00, 0x7e, 0xd8, 0xd8, 0x70, 0x00], // 0xb9
	[0x03, 0x06, 0x0c, 0x3c, 0x66, 0x3c, 0x60, 0xc0], // 0xba
	[0x03, 0x06, 0x0c, 0x66, 0x66, 0x3c, 0x60, 0xc0], // 0xbb
	[0x00, 0xe6, 0x3c, 0x18, 0x38, 0x6c, 0xc7, 0x00], // 0xbc
	[0x00, 0x00, 0x66, 0xc3, 0xdb, 0xdb, 0x7e, 0x00], // 0xbd
	[0xfe, 0xc6, 0x60, 0x30, 0x60, 0xc6, 0xfe, 0x00], // 0xbe
	[0x00, 0x7c, 0xc6, 0xc6, 0xc6, 0x6c, 0xee, 0x00], // 0xbf
	[0x18, 0x30, 0x60, 0xc0, 0x80, 0x00, 0x00, 0x00], // 0xc0
	[0x18, 0x0c, 0x06, 0x03, 0x01, 0x00, 0x00, 0x00], // 0xc1
	[0x00, 0x00, 0x00, 0x01, 0x03, 0x06, 0x0c, 0x18], // 0xc2
	[0x00, 0x00, 0x00, 0x80, 0xc0, 0x60, 0x30, 0x18], // 0xc3
	[0x18, 0x3c, 0x66, 0xc3, 0x81, 0x00, 0x00, 0x00], // 0xc4
	[0x18, 0x0c, 0x06, 0x03, 0x03, 0x06, 0x0c, 0x18], // 0xc5
	[0x00, 0x00, 0x00, 0x81, 0xc3, 0x66, 0x3c, 0x18], // 0xc6
	[0x18, 0x30, 0x60, 0xc0, 0xc0, 0x60, 0x30, 0x18], // 0xc7
	[0x18, 0x30, 0x60, 0xc1, 0x83, 0x06, 0x0c, 0x18], // 0xc8
	[0x18, 0x0c, 0x06, 0x83, 0xc1, 0x60, 0x30, 0x18], // 0xc9
	[0x18, 0x3c, 0x66, 0xc3, 0xc3, 0x66, 0x3c, 0x18], // 0xca
	[0xc3, 0xe7, 0x7e, 0x3c, 0x3c, 0x7e, 0xe7, 0xc3], // 0xcb
	[0x03, 0x07, 0x0e, 0x1c, 0x38, 0x70, 0xe0, 0xc0], // 0xcc
	[0xc0, 0xe0, 0x70, 0x38, 0x1c, 0x0e, 0x07, 0x03], // 0xcd
	[0xcc, 0xcc, 0x33, 0x33, 0xcc, 0xcc, 0x33, 0x33], // 0xce
	[0xaa, 0x55, 0xaa, 0x55, 0xaa, 0x55, 0xaa, 0x55], // 0xcf
	[0xff, 0xff, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], // 0xd0
	[0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03], // 0xd1
	[0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xff, 0xff], // 0xd2
	[0xc0, 0xc0, 0xc0, 0xc0, 0xc0, 0xc0, 0xc0, 0xc0], // 0xd3
	[0xff, 0xfe, 0xfc, 0xf8, 0xf0, 0xe0, 0xc0, 0x80], // 0xd4
	[0xff, 0x7f, 0x3f, 0x1f, 0x0f, 0x07, 0x03, 0x01], // 0xd5
	[0x01, 0x03, 0x07, 0x0f, 0x1f, 0x3f, 0x7f, 0xff], // 0xd6
	[0x80, 0xc0, 0xe0, 0xf0, 0xf8, 0xfc, 0xfe, 0xff], // 0xd7
	[0xaa, 0x55, 0xaa, 0x55, 0x00, 0x00, 0x00, 0x00], // 0xd8
	[0x0a, 0x05, 0x0a, 0x05, 0x0a, 0x05, 0x0a, 0x05], // 0xd9
	[0x00, 0x00, 0x00, 0x00, 0xaa, 0x55, 0xaa, 0x55], // 0xda
	[0xa0, 0x50, 0xa0, 0x50, 0xa0, 0x50, 0xa0, 0x50], // 0xdb
	[0xaa, 0x54, 0xa8, 0x50, 0xa0, 0x40, 0x80, 0x00], // 0xdc
	[0xaa, 0x55, 0x2a, 0x15, 0x0a, 0x05, 0x02, 0x01], // 0xdd
	[0x01, 0x02, 0x05, 0x0a, 0x15, 0x2a, 0x55, 0xaa], // 0xde
	[0x00, 0x80, 0x40, 0xa0, 0x50, 0xa8, 0x54, 0xaa], // 0xdf
	[0x7e, 0xff, 0x99, 0xff, 0xbd, 0xc3, 0xff, 0x7e], // 0xe0
	[0x7e, 0xff, 0x99, 0xff, 0xc3, 0xbd, 0xff, 0x7e], // 0xe1
	[0x38, 0x38, 0xfe, 0xfe, 0xfe, 0x10, 0x38, 0x00], // 0xe2
	[0x10, 0x38, 0x7c, 0xfe, 0x7c, 0x38, 0x10, 0x00], // 0xe3
	[0x6c, 0xfe, 0xfe, 0xfe, 0x7c, 0x38, 0x10, 0x00], // 0xe4
	[0x10, 0x38, 0x7c, 0xfe, 0xfe, 0x10, 0x38, 0x00], // 0xe5
	[0x00, 0x3c, 0x66, 0xc3, 0xc3, 0x66, 0x3c, 0x00], // 0xe6
	[0x00, 0x3c, 0x7e, 0xff, 0xff, 0x7e, 0x3c, 0x00], // 0xe7
	[0x00, 0x7e, 0x66, 0x66, 0x66, 0x66, 0x7e, 0x00], // 0xe8
	[0x00, 0x7e, 0x7e, 0x7e, 0x7e, 0x7e, 0x7e, 0x00], // 0xe9
	[0x0f, 0x07, 0x0d, 0x78, 0xcc, 0xcc, 0xcc, 0x78], // 0xea
	[0x3c, 0x66, 0x66, 0x66, 0x3c, 0x18, 0x7e, 0x18], // 0xeb
	[0x0c, 0x0c, 0x0c, 0x0c, 0x0c, 0x3c, 0x7c, 0x38], // 0xec
	[0x18, 0x1c, 0x1e, 0x1b, 0x18, 0x78, 0xf8, 0x70], // 0xed
	[0x99, 0x5a, 0x24, 0xc3, 0xc3, 0x24, 0x5a, 0x99], // 0xee
	[0x10, 0x38, 0x38, 0x38, 0x38, 0x38, 0x7c, 0xd6], // 0xef
	[0x18, 0x3c, 0x7e, 0xff, 0x18, 0x18, 0x18, 0x18], // 0xf0
	[0x18, 0x18, 0x18, 0x18, 0xff, 0x7e, 0x3c, 0x18], // 0xf1
	[0x10, 0x30, 0x70, 0xff, 0xff, 0x70, 0x30, 0x10], // 0xf2
	[0x08, 0x0c, 0x0e, 0xff, 0xff, 0x0e, 0x0c, 0x08], // 0xf3
	[0x00, 0x00, 0x18, 0x3c, 0x7e, 0xff, 0xff, 0x00], // 0xf4
	[0x00, 0x00, 0xff, 0xff, 0x7e, 0x3c, 0x18, 0x00], // 0xf5
	[0x80, 0xe0, 0xf8, 0xfe, 0xf8, 0xe0, 0x80, 0x00], // 0xf6
	[0x02, 0x0e, 0x3e, 0xfe, 0x3e, 0x0e, 0x02, 0x00], // 0xf7
	[0x38, 0x38, 0x92, 0x7c, 0x10, 0x28, 0x28, 0x28], // 0xf8
	[0x38, 0x38, 0x10, 0xfe, 0x10, 0x28, 0x44, 0x82], // 0xf9
	[0x38, 0x38, 0x12, 0x7c, 0x90, 0x28, 0x24, 0x22], // 0xfa
	[0x38, 0x38, 0x90, 0x7c, 0x12, 0x28, 0x48, 0x88], // 0xfb
	[0x00, 0x3c, 0x18, 0x3c, 0x3c, 0x3c, 0x18, 0x00], // 0xfc
	[0x3c, 0xff, 0xff, 0x18, 0x0c, 0x18, 0x30, 0x18], // 0xfd
	[0x18, 0x3c, 0x7e, 0x18, 0x18, 0x7e, 0x3c, 0x18], // 0xfe
	[0x00, 0x24, 0x66, 0xff, 0x66, 0x24, 0x00, 0x00] //  0xff
];

/* eslint-enable array-element-newline */
